module.exports = __webpack_public_path__ + "img/ryu-min.51636af0.png";